export const RECAPTCHA_TOKEN = process.env.REACT_APP_PARCELAMOS_RECAPTCHA_TOKEN

export const X_TOKEN_AUTOMATION = process.env.REACT_APP_X_TOKEN_AUTOMATION

export function isEnvironmentTest() {
  return !!X_TOKEN_AUTOMATION
}
